import React from 'react';
import { connect } from 'react-redux';
import { getUser } from '../../store/User/actions/getUser';
import { getBranding } from '../../store/Branding/actions/getBranding';
import {
    hideTrialBarEvent,
    modalClosed,
    removeNotification,
    setShowCertifiedModal,
    toggleNewRequestModal,
    setDashboardNewRequestModal,
} from '../../store/EventData/actions/eventData';
import { AppsWrapper } from './AppsWrapper/AppsWrapper';
import { TopMenu } from './AppsWrapper/TopMenu/TopMenu';
import { EventsReceiver } from './EventsReceiver';
import { ToastsWrapper } from '../../components/ToastsWrapper/ToastsWrapper';
import { SingleSpaContainer } from '../../components/SingleSpaContainer/SingleSpaContainer';
import { SideNavigationMenu } from './SideNavigationMenu/SideNavigationMenu';
import Zendesk from 'react-zendesk';
import { zendeskSettings } from '../../../helpers/ZendeskUtils';
import { CircularProgress } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import * as singleSpa from 'single-spa';

import {
    ISideNavigationMenuItemsConfig,
    sideMenuConfigurationItems,
    SideItemMenuSectionsName,
} from './SideNavigationMenu/SideNavigationMenuConfiguration';
import { userMenuConfig } from './AppsWrapper/TopMenu/TopMenuConfiguration';
import { UserMenuConfig } from './AppsWrapper/TopMenu/UserMenu/UserMenu';

import './Dashboard.scss';

import {
    DASHBOARD_NEW_REQUEST_MODAL_CLOSED,
    EVENTS_NEW_TEMPLATE_CERTIFIED,
    EVENTS_OPEN_CERTIFIED_EMAIL_MODAL,
    EVENTS_OPEN_CERTIFIED_SMS_MODAL,
    EVENTS_OPEN_NEW_CERTIFIED_FILE_MODAL,
    SHOW_SENDBOARD_LEAVE_MODAL,
} from '../../constants/events';
import { URL_TEMPLATE_EDITOR } from '../../constants/productsUrlHashes';
import { UserFixedNotifications } from '../../components/UserFixedNotifications/UserFixedNotifications';
import { CertifiedFileModal } from '../../components/CertifiedFileModal/CertifiedFileModal';
import { MENU_LINKS } from '../../../config/routes';
import { TrialNotifications } from '../../components/TrialNotifications/TrialNotifications';
import { getNewNotificationsSectionsWithTag } from '../../../helpers/TagsHelper';
import { GlobalEventDistributor } from '../../../init/globalEventDistributor';
import { getActiveProducts } from '../../store/Products/actions/getActiveProducts';
import { getExtendedProducts } from '../../store/Products/actions/getExtendedProducts';
import { storeOnboardingData } from '../../store/User/actions/storeOnboardingData';
import { OnboardingNotifications } from '../../../models/OnboardingNotifications';

import { sendDataTrackerEventHandler } from '../../dataTracker/DataTrackerHelper';
import { DataTrackerEvents } from '../../dataTracker/DataTrackerEvents';
import { useRefreshDataHOC } from '../../../hooks/useRefreshDataHOC';
import { UserAlertNotification } from '../../components/UserAlertNotification/UserAlertNotification';
import { ActivationEmailModal } from '../../components/ActivationEmailModal/ActivationEmailModal';
import {
    isCollapsibleMenu,
    isToggleAllComponents,
    shouldShowActivationEmailModal,
    shouldShowTemplatesMicro,
} from './componenDidUpdateHelper';
import { User } from '../../../models/User';
import { ActiveProduct } from '../../../models/ActiveProduct';
import { ExtendedProducts } from '../../../models/ExtendedProducts';
import { showTagOnItemMenu } from '../../../helpers/OnboardingNotificationHelper';
import { Branding, IBrandingPayload } from '../../../models/Branding';
import { getCurrentLanguage } from '../../../helpers/LangHelper';
import { LOCAL_LOGIN_URL, NEW_LOGIN_URL } from '../../../main/constants/endpoints';
import { getPermissions } from '../../../helpers/PermissionsHelper';
import { NewRequestModal } from '../../components/NewRequestModal/NewRequestModal';
import { dashboardNewRequestModalAction } from '../../store/EventData/types';
import dayjs from 'dayjs';

const ZENDESK_API_KEY = `${process.env.ZENDESK_API_KEY}`;
const FROM_REQUEST = 'fromRequest';
const FROM_TEMPLATES = 'fromTemplates';

type CloseModalEventDetail = {
    content: {
        detail: {
            historyBack: boolean;
        };
    };
};

export interface SGAppProps {
    getUser: typeof getUser;
    getBranding: typeof getBranding;
    getActiveProducts: typeof getActiveProducts;
    getExtendedProducts: typeof getExtendedProducts;
    removeNotification: typeof removeNotification;
    toggleNewRequestModal: typeof toggleNewRequestModal;
    hideFixedNotificationsWrapper: boolean;
    hideTrialBar: boolean;
    extendedProducts: ExtendedProducts;
    activeProducts: ActiveProduct[];
    userPermissions: string[];
    notifications: any[];
    menuConfig: ISideNavigationMenuItemsConfig[];
    user: User;
    onboardingNotifications: OnboardingNotifications;
    openNewRequestModal: boolean;
    isNotAuthenticated: boolean;
    closeModalEventDetail: any;
    closeConfirmLeaveModalEventDetail: any;
    showCertifiedModal: boolean;
    branding: InstanceType<typeof Branding>;
    setShowCertifiedModal: typeof setShowCertifiedModal;
    storeOnboardingData: typeof storeOnboardingData;
    hideTrialBarEvent: typeof hideTrialBarEvent;
    dashboardNewRequestModal: dashboardNewRequestModalAction['payload'];
    setDashboardNewRequestModal: typeof setDashboardNewRequestModal;
}

class Dashboard extends React.Component<SGAppProps, any> {
    private globalEventDistributor: GlobalEventDistributor;

    constructor(props: SGAppProps) {
        super(props);
        this.state = {
            hamburgerClicked: false,
            showTemplateScreen: null,
            toasts: [],
            zendeskConfigured: false,
            zendeskLoaded: false,
            showCertificateButton: false,
            isDisabledButton: false,
            currentUrlHash: MENU_LINKS.REQUEST_LIST.ALL.LINK,
            menuConfig: [],
            userMenuConfig: [],
            userPermissions: [],
            showAutoNewRequestModal: true,
            toggleAllComponents: true,
            isSendboard: false,
            showAlertNotification: false,
            showActivationEmailModal: false,
            showTemplatesMicro: false,
        };
        this.globalEventDistributor = window['DashboardV2'].globalEventDistributor;
    }

    componentDidMount() {
        this.props.getUser();
        this.props.getBranding();
        this.props.getActiveProducts();
        this.props.getExtendedProducts();
        this.listenHashChange();
        this.detectUrlHash();
    }

    componentWillUnmount() {
        window.onhashchange = null;
    }

    componentDidUpdate(prevProps: Readonly<SGAppProps>, prevState: Readonly<any>) {
        this.isNotificationDismissed();
        this.checkUserCodename(prevProps.user);
        this.checkCurrentUrlHash(prevState.currentUrlHash);
        this.checkIsNotAuthenticated(prevProps.isNotAuthenticated);
        this.checkUser(prevProps.user);
        this.checkUserPermissions(prevProps.userPermissions);
        this.checkOpenNewRequestModal(prevProps.openNewRequestModal);
        this.checkCloseModalEventDetail(prevProps.closeModalEventDetail);
        this.checkInitUserProps(prevProps.extendedProducts, prevProps.onboardingNotifications, prevProps.branding);
        this.checkCloseConfirmLeaveModalEventDetail(prevProps.closeConfirmLeaveModalEventDetail);
    }

    private checkUserCodename = (prevPropsUser: User): void => {
        if (prevPropsUser?.codename !== this.props.user?.codename) {
            this.setState({
                showActivationEmailModal: shouldShowActivationEmailModal(this.state.currentUrlHash, this.props.user),
                showAlertNotification: false,
            });
        }
    };

    private checkCurrentUrlHash = (prevStateCurrentUrlHash: string): void => {
        if (prevStateCurrentUrlHash !== this.state.currentUrlHash) {
            this.setState({
                toggleAllComponents: isToggleAllComponents(this.state.currentUrlHash),
                showTemplatesMicro: shouldShowTemplatesMicro(this.state.currentUrlHash),
                isSendboard: isCollapsibleMenu(this.state.currentUrlHash),
            });
            this.toggleNewTagVisited();
        }
    };

    private checkIsNotAuthenticated = (prevPropsIsNotAuthenticated: boolean): void => {
        const isNotAuthAndHasLoginUrl = this.props.isNotAuthenticated;
        if (prevPropsIsNotAuthenticated !== this.props.isNotAuthenticated && isNotAuthAndHasLoginUrl) {
            const urlParameterToRedirect = '_redirect';
            const urlParams = `${urlParameterToRedirect}=${window.location.href}`;
            const loginUrl = !!LOCAL_LOGIN_URL
                ? `${LOCAL_LOGIN_URL}?${urlParams}`
                : `${NEW_LOGIN_URL}/${getCurrentLanguage()}/login?${urlParams}`;

            window.location.href = loginUrl;
        }
    };

    private checkUser = (prevPropsUser: User): void => {
        if (prevPropsUser !== this.props.user && this.props.user) {
            this.updatePermissions();
            this.setUserConfigs();
        }
    };

    private checkUserPermissions = (prevPropsUserPermissions: string[]): void => {
        if (prevPropsUserPermissions !== this.props.userPermissions && this.props.userPermissions) {
            this.setUserConfigs();
        }
    };

    private checkOpenNewRequestModal = (prevPropsOpenNewRequestModal: boolean): void => {
        if (prevPropsOpenNewRequestModal !== this.props.openNewRequestModal && this.props.openNewRequestModal) {
            this.handleOpenNewRequestModal();
        }
    };

    private checkCloseModalEventDetail = (prevPropsCloseModalEventDetail: CloseModalEventDetail | undefined): void => {
        if (prevPropsCloseModalEventDetail !== this.props.closeModalEventDetail) {
            this.onCloseModal();

            if (this.props.openNewRequestModal) {
                this.props.toggleNewRequestModal(false);
            }
        }
    };

    private checkInitUserProps = (
        prevPropsExtendedProducts: ExtendedProducts,
        prevPropsOnboardingNotifications: OnboardingNotifications,
        prevPropsBranding: IBrandingPayload
    ): void => {
        if (
            prevPropsExtendedProducts !== this.props.extendedProducts ||
            prevPropsOnboardingNotifications !== this.props.onboardingNotifications ||
            prevPropsBranding !== this.props.branding
        ) {
            this.updatePermissions();
            this.setUserConfigs();
        }
    };

    private checkCloseConfirmLeaveModalEventDetail = (prevPropsCloseConfirmLeaveModalEventDetail: unknown): void => {
        if (
            this.props.closeConfirmLeaveModalEventDetail &&
            prevPropsCloseConfirmLeaveModalEventDetail !== this.props.closeConfirmLeaveModalEventDetail
        ) {
            window.location.href = MENU_LINKS.REQUEST_LIST.ALL.LINK;
        }
    };

    private detectUrlHash: () => void = () => {
        if (window.location.hash !== this.state.currentUrlHash) {
            this.setState({ currentUrlHash: window.location.hash });
        }

        this.props.setDashboardNewRequestModal({
            ...this.props.dashboardNewRequestModal,
            open: window.location.hash === MENU_LINKS.TEMPLATES.NEW_REQUEST,
        });
    };

    private listenHashChange: () => void = () => {
        window.onhashchange = (event: HashChangeEvent) => {
            const oldHashURL: string | undefined = event.oldURL ? `#${event.oldURL.split('#')[1]}` : undefined;
            const currentUrlHash = (event.target as Window).location.hash;
            const showActivationEmailModal = shouldShowActivationEmailModal(currentUrlHash, this.props.user);
            this.setState({
                showActivationEmailModal,
                currentUrlHash,
                oldHashURL,
            });

            this.props.setDashboardNewRequestModal({
                ...this.props.dashboardNewRequestModal,
                open: !showActivationEmailModal && currentUrlHash === MENU_LINKS.TEMPLATES.NEW_REQUEST,
            });
        };
    };

    private toggleNewTagVisited: () => void = () => {
        const visitedSection: ISideNavigationMenuItemsConfig | UserMenuConfig =
            this.state.menuConfig.find(
                (item: ISideNavigationMenuItemsConfig) => this.state.currentUrlHash.indexOf(item.baseLink) !== -1
            ) ||
            this.state.userMenuConfig.find(
                (item: UserMenuConfig) => this.state.currentUrlHash.indexOf(item.link) !== -1
            );

        const isHomeSection: boolean = visitedSection?.name === SideItemMenuSectionsName.HOME;

        if (visitedSection && !isHomeSection) {
            this.props.onboardingNotifications.visitSection(visitedSection.name);
            this.props.storeOnboardingData(this.props.onboardingNotifications);
        }
    };

    private isNotificationDismissed = () => {
        if (this.props.notifications) {
            this.props.notifications.forEach((notification: any) => {
                if (notification.dismissed) {
                    this.props.removeNotification();
                }
            });
        }
    };

    public updatePermissions = (): void => {
        const { user, activeProducts, extendedProducts } = this.props;
        this.setState({
            userPermissions: getPermissions({ user, extendedProducts, activeProducts, permissions: undefined }),
        });
    };

    public setUserConfigs = (): void => {
        this.setState({
            menuConfig: this.getMenuConfiguration(),
            userMenuConfig: this.getUserMenuConfiguration(),
        });
    };

    public handleOpenMenu = (): void => this.setState({ hamburgerClicked: true });
    public handleCloseMenu = (): void => this.setState({ hamburgerClicked: false });

    public setTemplateScreen = (showTemplateScreen: boolean | null): void => this.setState({ showTemplateScreen });

    private dispatchOpenCertifiedModal = (
        eventName: typeof EVENTS_OPEN_CERTIFIED_EMAIL_MODAL | typeof EVENTS_OPEN_CERTIFIED_SMS_MODAL
    ) => {
        this.props.setDashboardNewRequestModal({
            ...this.props.dashboardNewRequestModal,
            open: false,
        });
        const { user } = this.props;
        this.globalEventDistributor.dispatchEvent(eventName, {
            user: {
                account_id: user.accountId,
                account_configs: { max_file_size: user.accountConfigs?.maxFileSize },
                account: { id: user.accountId },
            },
        });
    };

    public dispatchCertifiedEmailEvent = () => {
        this.dispatchOpenCertifiedModal(EVENTS_OPEN_CERTIFIED_EMAIL_MODAL);
    };

    public dispatchCertifiedSmsEvent = () => {
        this.dispatchOpenCertifiedModal(EVENTS_OPEN_CERTIFIED_SMS_MODAL);
    };

    public dispatchNewTemplateEvent = () => {
        if (this.props.extendedProducts.account.newTemplates) {
            const waitForEvent = (
                eventDistributor: {
                    registerStore?: Function;
                    listenEvent: any;
                    removeEvent?: Function;
                    dispatchEvent?: Function;
                },
                eventName: string
            ) => new Promise<void>((resolve) => eventDistributor.listenEvent(eventName, resolve));

            waitForEvent(this.globalEventDistributor, 'listeners-set').then(() => {
                this.globalEventDistributor.dispatchEvent(EVENTS_NEW_TEMPLATE_CERTIFIED);
            });
        } else {
            this.globalEventDistributor.dispatchEvent(EVENTS_NEW_TEMPLATE_CERTIFIED);
        }
    };

    public onCloseModal = () => {
        const { closeModalEventDetail: event } = this.props;
        const isBackHistoryAllowed = !!event?.content?.detail?.historyBack ?? true;
        if (isBackHistoryAllowed) {
            singleSpa.navigateToUrl(event?.content?.detail?.destination ?? MENU_LINKS.REQUEST_LIST.ALL.LINK);
        }
    };

    public handleOpenNewRequestModal = () => {
        this.props.setDashboardNewRequestModal({ open: true, requestOrigin: FROM_REQUEST });

        let currentUrlHash = window.location.hash;

        this.setState({
            isSendboard: isCollapsibleMenu(currentUrlHash),
        });

        if (this.state.isSendboard) {
            this.handleOpenSendboardLeaveModal(MENU_LINKS.TEMPLATES.NEW_REQUEST);
            this.props.setDashboardNewRequestModal({
                ...this.props.dashboardNewRequestModal,
                requestOrigin: FROM_REQUEST,
            });
            return;
        }

        if (
            !this.state.currentUrlHash.includes(URL_TEMPLATE_EDITOR) &&
            !this.state.currentUrlHash.includes(MENU_LINKS.TEMPLATES.NEW_REQUEST)
        ) {
            window.location.href = MENU_LINKS.TEMPLATES.NEW_REQUEST;
            this.setState({ showAutoNewRequestModal: false });
        } else if (this.state.currentUrlHash.includes(MENU_LINKS.TEMPLATES.NEW_REQUEST)) {
            currentUrlHash = MENU_LINKS.REQUEST_LIST.ALL.LINK;
        }

        this.setState({ currentUrlHash });

        this.props.setDashboardNewRequestModal({ open: true, requestOrigin: FROM_REQUEST });

        sendDataTrackerEventHandler(DataTrackerEvents.clickNewRequestButton);
    };

    public userPaymentNotificationAvailable = () => this.props && this.props.user && this.props.user.notifications;

    public handlePaymentRedirection = () => {
        const inPaymentUrl = this.state.currentUrlHash.includes(MENU_LINKS.PAYMENT.BASE);
        if (this.userPaymentNotificationAvailable()) {
            const {
                inVerification,
                paymentRefused,
                desiredLicense,
                desiredLicensePeriod,
            } = this.props.user.notifications;

            const hasPaymentRefused = inVerification && paymentRefused;
            const redirectToPayment = !inPaymentUrl && hasPaymentRefused;

            if (redirectToPayment) {
                const userPaymentHash = `${MENU_LINKS.PAYMENT.BASE}/${desiredLicense}/${desiredLicensePeriod}?resultCode=Refused`;
                window.location.hash = userPaymentHash;
            }
        }
    };

    public handleOpenNewCertifiedFileModal = () =>
        this.globalEventDistributor.dispatchEvent(EVENTS_OPEN_NEW_CERTIFIED_FILE_MODAL);

    public handleOpenSendboardLeaveModal = (routeToGo: string): void =>
        this.globalEventDistributor.dispatchEvent(SHOW_SENDBOARD_LEAVE_MODAL, routeToGo);

    public getMenuConfiguration() {
        const { user, extendedProducts, onboardingNotifications, branding } = this.props;
        const sectionsWithTag = getNewNotificationsSectionsWithTag(user, extendedProducts);
        const sectionsWithTagToDisplay = sectionsWithTag.filter((section: string) =>
            section === SideItemMenuSectionsName.HOME
                ? showTagOnItemMenu(onboardingNotifications, section, OnboardingNotifications.HOME_DAYS_CONFIGURATION)
                : showTagOnItemMenu(onboardingNotifications, section)
        );
        this.props.storeOnboardingData(onboardingNotifications);

        return sideMenuConfigurationItems(
            {
                user: user,
                extendedProducts,
                hiddenSections: branding?.hiddenSections,
                permissions: this.state.userPermissions,
            },
            sectionsWithTagToDisplay
        );
    }

    public getUserMenuConfiguration() {
        const { user, activeProducts, branding } = this.props;
        return userMenuConfig({
            user,
            activeProducts,
            hiddenSections: branding?.hiddenSections,
            permissions: this.state.userPermissions,
        });
    }

    public onCloseCertifiedModal = () => this.props.setShowCertifiedModal(false);

    onIsActive = (isActive: boolean) =>
        this.setState({
            showAlertNotification: isActive,
        });

    hasTrialExpired = (user: User): boolean => {
        if (user) {
            const {
                adHoc,
                isTrial,
                notifications: { trialExpiresAt },
            } = user;

            const isBeforeToday = dayjs(trialExpiresAt).isBefore(dayjs());

            return !adHoc && isTrial && isBeforeToday;
        }
        return false;
    };

    onCloseNewRequestModal = (isClosed: boolean) => {
        this.props.setDashboardNewRequestModal({
            ...this.props.dashboardNewRequestModal,
            open: !isClosed,
        });
        this.globalEventDistributor.dispatchEvent(DASHBOARD_NEW_REQUEST_MODAL_CLOSED);

        const defaultHashURL =
            this.props.dashboardNewRequestModal.requestOrigin === FROM_TEMPLATES
                ? MENU_LINKS.TEMPLATES.BASE
                : MENU_LINKS.REQUEST_LIST.ALL.LINK;

        singleSpa.navigateToUrl(defaultHashURL);
    };

    render() {
        const {
            handleOpenNewRequestModal,
            handleOpenNewCertifiedFileModal,
            handleOpenSendboardLeaveModal,
            onCloseCertifiedModal,
            onIsActive,
            onCloseNewRequestModal,
            dispatchCertifiedEmailEvent,
            dispatchCertifiedSmsEvent,
            dispatchNewTemplateEvent,
            hasTrialExpired,
        } = this;

        const {
            user,
            showCertifiedModal,
            extendedProducts,
            activeProducts,
            hideFixedNotificationsWrapper,
            dashboardNewRequestModal,
        } = this.props;

        const {
            hamburgerClicked,
            currentUrlHash,
            toggleAllComponents,
            menuConfig,
            isSendboard,
            showAlertNotification,
            showActivationEmailModal,
            userPermissions,
        } = this.state;

        const loadingTPL = <CircularProgress />;
        const isTrial = user?.isTrial && !this.props.hideTrialBar;
        const isTrialOver = hasTrialExpired(user);
        const qualifiedSignatures = extendedProducts?.account.qualifiedSignatures;

        this.handlePaymentRedirection();

        const hasRequiredData = !isEmpty(user) && extendedProducts && activeProducts;
        const showSideMenu = hasRequiredData && (toggleAllComponents || isSendboard);
        const showUserAlert = !isSendboard && (isTrial || showAlertNotification);

        return (
            <>
                {!hasRequiredData && <div className="dashboard__loading">{loadingTPL}</div>}
                <CertifiedFileModal open={showCertifiedModal || false} onClose={onCloseCertifiedModal} />
                <NewRequestModal
                    open={dashboardNewRequestModal?.open || false}
                    onClose={onCloseNewRequestModal}
                    onClickCertifiedEmail={dispatchCertifiedEmailEvent}
                    onClickCertifiedSms={dispatchCertifiedSmsEvent}
                    onTemplateCertified={dispatchNewTemplateEvent}
                    activeProducts={activeProducts}
                    requestOrigin={dashboardNewRequestModal?.requestOrigin || FROM_REQUEST}
                    isTrialOver={isTrialOver}
                    qualifiedSignatures={qualifiedSignatures}
                />
                <Zendesk
                    zendeskKey={ZENDESK_API_KEY}
                    {...zendeskSettings}
                    onLoaded={() =>
                        this.setState({
                            zendeskLoaded: true,
                        })
                    }
                />
                {toggleAllComponents && <UserAlertNotification onIsActive={onIsActive} />}
                {isTrial && toggleAllComponents && <TrialNotifications />}
                <div className={'dashboard__container' + (showUserAlert ? ' trialActive' : '')}>
                    <EventsReceiver globalEventDistributor={this.globalEventDistributor} />
                    {showSideMenu && (
                        <SideNavigationMenu
                            currentHash={currentUrlHash}
                            isTrialActive={showUserAlert}
                            expand={hamburgerClicked}
                            isCollapsible={isSendboard}
                            menuConfig={menuConfig}
                            handleOpenNewCertifiedFileModal={handleOpenNewCertifiedFileModal}
                            handleOpenNewRequestModal={handleOpenNewRequestModal}
                            handleOpenSendboardLeaveModal={handleOpenSendboardLeaveModal}
                            permissions={userPermissions}
                            handleDrawerToggle={this.handleCloseMenu}
                        />
                    )}
                    <AppsWrapper darken={false}>
                        {toggleAllComponents && (
                            <TopMenu
                                clickAction={this.handleOpenMenu}
                                user={user}
                                activeProducts={activeProducts}
                                extendedProducts={extendedProducts}
                                permissions={userPermissions}
                            />
                        )}
                        {!hideFixedNotificationsWrapper && toggleAllComponents && <UserFixedNotifications />}
                        <ToastsWrapper notifications={this.props.notifications} />
                        <section className={`dashboard__micro${isTrial ? ' trialActive' : ''}`}>
                            {showActivationEmailModal && <ActivationEmailModal />}

                            <SingleSpaContainer
                                showTemplatesMicro={this.state.showTemplatesMicro}
                                showTemplateScreen={this.state.showTemplateScreen}
                            />
                        </section>
                    </AppsWrapper>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        notifications: state.evtData.notifications,
        user: state.user.item,
        branding: state.branding.item,
        onboardingNotifications: state.user.onboardingNotifications,
        isNotAuthenticated: state.user.isNotAuthenticated,
        activeProducts: state.products.activeProducts,
        extendedProducts: state.products.extendedProducts,
        closeModalEventDetail: state.evtData.closeModalEventDetail,
        closeConfirmLeaveModalEventDetail: state.evtData.closeConfirmLeaveModalEventDetail,
        openNewRequestModal: state.evtData.openNewRequestModal,
        showCertifiedModal: state.evtData.showCertifiedModal,
        hideTrialBar: state.evtData.hideTrialBar,
        hideFixedNotificationsWrapper: state.evtData.hideFixedNotificationsWrapper,
        dashboardNewRequestModal: state.evtData.dashboardNewRequestModal,
    };
};

const DashboardComponent = useRefreshDataHOC(Dashboard);

export default connect(mapStateToProps, {
    getUser,
    getBranding,
    getActiveProducts,
    getExtendedProducts,
    removeNotification,
    modalClosed,
    toggleNewRequestModal,
    setShowCertifiedModal,
    storeOnboardingData,
    hideTrialBarEvent,
    setDashboardNewRequestModal,
})(DashboardComponent);
